"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManifoldBridgeProvider = void 0;
const providers_1 = require("@ethersproject/providers");
const BRIDGE_ENDPOINTS = {
    1: 'https://bridge.manifoldxyz.dev/rpc',
    5: 'https://goerli.bridge.manifoldxyz.dev/rpc',
    10: 'https://optimism.bridge.manifoldxyz.dev/rpc',
    137: 'https://goerli.bridge.manifoldxyz.dev/rpc',
};
/**
 * JsonRpcProvider like provider to Manifold's web2 bridge
 */
class ManifoldBridgeProvider extends providers_1.JsonRpcProvider {
    constructor(network) {
        const endpoint = BRIDGE_ENDPOINTS[network];
        if (!endpoint)
            throw new Error('Unsupported network');
        super(endpoint, network);
    }
    static defaultUrl() {
        return '';
    }
    getSigner(_addressOrIndex) {
        throw new Error('No signer possible');
    }
    listAccounts() {
        return new Promise(() => {
            return [];
        });
    }
    send(method, params) {
        if (!['eth_call', 'eth_estimateGas'].includes(method)) {
            const error = new Error(`${method} not supported`);
            error.code = -32004;
            error.data = `${method} not supported`;
            throw error;
        }
        return super.send(method, params);
    }
    detectNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.network;
        });
    }
}
exports.ManifoldBridgeProvider = ManifoldBridgeProvider;
